import { useGraphQLQuery } from '@betterment/graphql';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { LegalAccountTaxationType } from '../../../graphql/schema';
import IraContributionsOverviewCard from '../../../IraContributionsOverviewCard';
import { PurposeSubAccountTypesDocument } from '../../graphql/purposeSubAccountTypes.generated';

export const IraContributionsCard: React.FC = () => {
  const purposeId = useRequiredParam('purposeId');
  const { data } = useGraphQLQuery(PurposeSubAccountTypesDocument, { variables: { id: purposeId } });

  if (!data) return <CardLoader />;

  const subAccountTypes = data.purpose.envelope.legalSubAccounts.flatMap(sa => sa.legalAccount.taxationType);
  const iraTypes = new Set([LegalAccountTaxationType.RothIra, LegalAccountTaxationType.TraditionalIra]);

  if (!subAccountTypes.some(t => iraTypes.has(t))) return null;

  return (
    <ErrorBoundary fallbackType="none">
      <IraContributionsOverviewCard />
    </ErrorBoundary>
  );
};
